/**
 * Checks if the browser is in a testing/lighthouse environment
 * where realtime connections may fail.
 */
export const isTestingEnvironment = (): boolean => {
  if (typeof window === "undefined") return true;
  
  // Check for Lighthouse user agent
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes("lighthouse") || ua.includes("pagespeed")) {
    return true;
  }
  
  // Check for headless browsers commonly used in testing
  if (ua.includes("headless")) {
    return true;
  }
  
  // Check for Chrome DevTools Performance testing
  if (ua.includes("chrome-lighthouse")) {
    return true;
  }
  
  return false;
};

/**
 * Returns true if realtime subscriptions should be enabled.
 * Disabled in testing environments to prevent WebSocket errors.
 */
export const shouldEnableRealtime = (): boolean => {
  return !isTestingEnvironment();
};
